module.exports = __webpack_public_path__ + "static/media/ConCOVEbg.70733b9e.png";